import { ErrorBoundary } from "@circle-react/components/shared/ErrorBoundary";
import type { ReactNode } from "react";

import { SearchError } from "./SearchError";

interface SpotlightSearchErrorBoundaryProps {
  children: ReactNode;
}

export const SpotlightSearchErrorBoundary = ({
  children,
}: SpotlightSearchErrorBoundaryProps) => (
  <ErrorBoundary name="SpotlightSearchV4" fallback={SearchError}>
    {children}
  </ErrorBoundary>
);
